<template>
  <router-view></router-view>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const isMobile = ref(false);

const updateDocumentTitle = () => {
  if (route.name) {
    document.title = `FutureRent - ${route.name}`;
  }
};

onMounted(() => {
  // Set initial mobile state
  isMobile.value = window.innerWidth < 768;
  window.addEventListener("resize", () => {
    isMobile.value = window.innerWidth < 768;
  });

  // Set initial title
  updateDocumentTitle();
});

// Watch for route changes to update title
watch(
  () => route.name,
  () => {
    updateDocumentTitle();
  }
);
</script>
